import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { getAccountInfoAsync } from "../../services/accountService";
import ProfileHeading from "../Profile/components/ProfileHeading";
import ProfileTabs from "../Profile/components/ProfileTabs";
import Invoices from "./components/Invoices";
import Journal from "./components/Journals";
import Payments from "./components/Payments";

const AccountBilling = () => {
  const { id } = useParams();

  const [account, setAccount] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let mounted = true;

    const fetchAccount = async () => {
      setIsLoading(true);
      const result = await getAccountInfoAsync(id);

      if (result === null) return window.location("/404");

      if (mounted) {
        setAccount(result);
        setIsLoading(false);
      }
    };

    fetchAccount();

    return () => {
      mounted = false;
    };
  }, [id]);

  const tabs = [
    {
      id: 1,
      title: "Invoices",
      content: <Invoices id={id} />,
    },
    {
      id: 2,
      title: "Payments",
      content: <Payments id={id} />,
    },
    {
      id: 3,
      title: "Ledger",
      content: <Journal id={id} />,
    },
  ];

  return (
    <div className="mt-2">
      <div className="max-w-7xl mx-auto px-6 lg:px-0">
        <div className="grid grid-cols-2 gap-5">
          <div className="col-span-2">
            <div className="card p-6">
              <ProfileHeading
                data={account}
                setData={setAccount}
                isLoading={isLoading}
              />
            </div>
            <ProfileTabs items={tabs} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountBilling;
